<template>
    <div class="columns is-multiline">
        <div class="column is-full">
            <b-table
            :data="count > 0 ? customPages : []"
            :loading="loading"
            :hoverable="true">
                <template slot-scope="props">
                    <b-table-column width="40" numeric>
                    <a class="has-text-danger"
                    @click="pageToDelete=props.row; deleteModal=true">
                        <b-icon icon="trash" size="is-small">
                        </b-icon>
                    </a>
                </b-table-column>
                    <b-table-column label="Titulo">
                        <a :href="props.row.getStaffDetail">{{props.row.title}}</a>
                    </b-table-column>
                    <b-table-column label="Visible">
                        <b-tag v-if="props.row.visible" rounded type="is-success">
                            Visible
                        </b-tag>
                        <b-tag v-else rounded type="is-dark">
                            Oculta
                        </b-tag>
                    </b-table-column>
                    <b-table-column label="En menu">
                        <b-tag v-if="props.row.inNav" rounded type="is-success">
                            En menu
                        </b-tag>
                        <b-tag v-else rounded type="is-dark">
                            Oculta
                        </b-tag>
                    </b-table-column>
                </template>
                <template slot="empty">
                    <section class="section">
                        <div class="content has-text-grey has-text-centered">
                            <p>
                                <b-icon
                                    icon="frown"
                                    size="is-large">
                                </b-icon>
                            </p>
                            <p>Todavia no creaste ninguna pagina.</p>
                        </div>
                    </section>
                </template>
            </b-table>
        </div>
        <div class="column is-full">
            <b-pagination
                :total="count"
                :per-page="perPage"
                :current.sync="page"
                :range-before="2"
                :rounded="true"
                :range-after="2"
                order="is-centered"
                @change="onPageChange"
                icon-prev="chevron-left"
                icon-next="chevron-right"
            >
            </b-pagination>
        </div>
        <div class="column is-full has-text-centered">
            <b-button
            type="is-primary"
            rounded
            @click="goToForm">
                Crear una nueva pagina
                <b-icon icon="plus" size="is-small"></b-icon>
            </b-button>
        </div>

        <b-modal :active.sync="deleteModal" scroll="keep" :can-cancel='false'>
            <div class="modal-card" style="width: auto">
                <div class="modal-card-body has-text-centered">
                    <p>Esta accion es irreversible</p>
                    <p>Seguro que quieres eliminar la pagina <b>"{{pageToDelete.title}}"</b> del sitio?</p>
                    <div class="columns m-t-20 ">
                        <div class="column is-full has-text-centered">
                            <b-button
                                type="is-grey"
                                rounded
                                @click="deleteModal=false">
                                    Cancelar
                            </b-button>
                            <b-button
                                type="is-danger"
                                rounded
                                @click="deletePage">
                                    Eliminar
                            </b-button>
                        </div>
                    </div>
                </div>
            </div>
        </b-modal>

    </div>
</template>

<script>
import { getHandler, deleteHandler } from '../../../services/http'
export default {
    props:{
        listPagesUrl:{
            type:String,
            default:""
        },
        formUrl:{
            type:String,
            default:""
        },
        deleteUrl:{
            type:String,
            default:""
        }
    },
    data(){
        return{
            loading:false,
            customPages:[],
            page:1,
            perPage:24,
            count:0,
            pageToDelete:{},
            deleteModal:false
        }
    },
    methods:{
        async fetchCustomPages(){
            var url = this.listPagesUrl + `?page=${this.page}`
            this.loading = true
            var response = await getHandler(url, {error:false, success:false})
            this.loading = false
            this.customPages = response.results
            this.count = response.count
        },
        async deletePage(){
            var error = {resource:'notify'}
            var success = {resource:'notify'}
            var url = this.deleteUrl.replace('0000', this.pageToDelete.id)
            var response = await deleteHandler(url, {error, success})
            this.deleteModal = false
            this.fetchCustomPages()
        },
        onPageChange(page){
            this.page = page
            this.fetchCustomPages
        },
        goToForm(){
            window.location.href = this.formUrl
        }
    },
    created(){
        this.fetchCustomPages()
    }
}
</script>